import { IAudio } from '../../models/Audio';
import { ActionType } from '../action-types';
import { Action } from '../actions';

const initialState: IAudio = {
	filter: '',
};

const reducer = (state: IAudio = initialState, action: Action): IAudio => {
	switch (action.type) {
		case ActionType.UPDATE_FILTER: {
			return {
				...state,
				filter: action.payload.filter,
			};
		}
		case ActionType.RESET_STATE: {
			return initialState;
		}
		default:
			return state;
	}
};

export default reducer;
